/*
  const original = { name: 'Alice', age: 30, email: 'alice@example.com', id: 123 };
  omit(original, ['age', 'email']);

  Output: { name: 'Alice', id: 123 }
*/
export const omit = <T extends object, K extends keyof T>(obj: T, keys: K[]): Omit<T, K> =>
	Object.fromEntries(Object.entries(obj).filter(([k]) => !keys.includes(k as K))) as Omit<T, K>;
